import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { emailTestPatterUnicode } from '../../../shared/utils';
import { Input } from '../../form_fields/common-field-styles';
import {
  SavedFormModalContent,
  LoaderAndMessageContainer,
  LoadingLines,
  CopyButton,
  ModalButton,
  SaveFormModalContent,
  InvalidEmailError,
} from './form-pagination.styled';

export default function FormPartialSubmission({
  email,
  viewLink,
  userCustomTexts,
  partialSubmissionLoading,
  savedFormID,
  handleCopyLink,
  setEmail,
  setOpenModal,
  setViewLink,
  onSavedFormPage,
  handleSaveAndContinueForm,
  formDesign,
}) {
  const inputRef = useRef(null);
  const [emailError, setEmailError] = useState('');
  const [isCopied, setIsCopied] = useState(false);
  const formLink = window.location.pathname.includes('/saved/')
    ? `${window.location.href}`
    : `${window.location.href}/saved/${savedFormID}`;

  useEffect(() => {
    if (inputRef?.current) {
      inputRef?.current?.focus();
    }
  });

  useEffect(() => {
    if (isCopied) {
      const timeOutId = setTimeout(() => setIsCopied(false), 2000);
      return () => clearTimeout(timeOutId);
    }
  }, [isCopied]);

  const onHandleSaveForm = (e) => {
    if (emailTestPatterUnicode.test(email)) {
      e.preventDefault();
      setViewLink(true);
      handleSaveAndContinueForm();
    }
    // else if (email.includes('@')) {
    //   e.preventDefault();
    // }
    else {
      setEmailError('Please provide a valid email address');
    }
  };

  return (
    <div className="modal-content">
      {viewLink || onSavedFormPage ? (
        <SavedFormModalContent
          style={{
            '--font-family': formDesign.old.form_font,
          }}>
          <div className="modal-header" />
          <form className="modal-body">
            <img
              className="link-img"
              src="https://storage.googleapis.com/fplsblog/3d-fluency-link.svg"
              alt="form link"
            />
            <div className="modal-subheader">
              <h3>{userCustomTexts.save_form_progress || 'Save Form Progress'}</h3>
              <p>
                {userCustomTexts.use_saveandContinue_link ||
                  'Use the link below to continue form submission at any time.'}
              </p>
            </div>
            <>
              {partialSubmissionLoading ? (
                <LoaderAndMessageContainer>
                  <LoadingLines partialSub />
                  <LoadingLines partialSub />
                  <LoadingLines partialSub />
                  <LoadingLines partialSub />
                </LoaderAndMessageContainer>
              ) : (
                <div className="modal-input-container">
                  <div className="modal-input">
                    <Input value={formLink} readOnly />
                    <CopyButton
                      isCopied={isCopied}
                      onClick={(e) => {
                        setIsCopied(true);
                        handleCopyLink(e, formLink);
                      }}>
                      {isCopied ? (
                        <>
                          <img src="https://storage.googleapis.com/fplsblog/post_submission_checkmark.svg" alt="" />
                          Link copied
                        </>
                      ) : (
                        <>
                          <img src="https://storage.googleapis.com/fplsblog/copy.svg" alt="copy-icon" />
                          Copy link
                        </>
                      )}
                    </CopyButton>
                  </div>
                  <i>{userCustomTexts.email_for_saved || 'An email has also been sent to you containing the link.'}</i>
                </div>
              )}
            </>
            {!partialSubmissionLoading && (
              <div className="modal-buttons-container">
                <ModalButton
                  className="close"
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenModal(false);
                  }}>
                  Close
                </ModalButton>
              </div>
            )}
          </form>
        </SavedFormModalContent>
      ) : (
        <SaveFormModalContent
          style={{
            '--font-family': formDesign.old.form_font,
          }}>
          <div className="modal-header">
            <h3>{userCustomTexts.save_form_progress || 'Save Form Progress'}</h3>
          </div>
          <form className="modal-body">
            <div className="email-info">
              <p>
                {userCustomTexts.email_for_link ||
                  'Enter your email address and get a link to complete this form later'}
              </p>
              <Input
                type="email"
                required
                ref={inputRef}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                $autoComplete
              />
              <InvalidEmailError>{emailError}</InvalidEmailError>
            </div>
            <div className="modal-buttons-container">
              <input
                type="submit"
                value={userCustomTexts.continue_text || 'Continue'}
                className="save"
                onClick={(e) => onHandleSaveForm(e)}
              />
            </div>
          </form>
        </SaveFormModalContent>
      )}
    </div>
  );
}

FormPartialSubmission.defaultProps = {
  email: null,
  handleCopyLink: () => null,
  partialSubmissionLoading: false,
  savedFormID: null,
  setEmail: () => null,
  setOpenModal: () => null,
  setViewLink: () => null,
  userCustomTexts: null,
  viewLink: false,
  onSavedFormPage: false,
  handleSaveAndContinueForm: () => null,
};

FormPartialSubmission.propTypes = {
  email: PropTypes.string,
  handleCopyLink: PropTypes.func,
  partialSubmissionLoading: PropTypes.bool,
  savedFormID: PropTypes.number,
  setEmail: PropTypes.func,
  setOpenModal: PropTypes.func,
  setViewLink: PropTypes.func,
  userCustomTexts: PropTypes.objectOf(PropTypes.string),
  viewLink: PropTypes.bool,
  onSavedFormPage: PropTypes.bool,
  handleSaveAndContinueForm: PropTypes.func,
  formDesign: PropTypes.shape({
    old: PropTypes.shape({
      form_font: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};
